







































import { Vue, Component, Prop } from "vue-property-decorator";
import CONFIG from "@/common/config";
import fetch from '@/common/api/fetch';
import getUrlParam from '@/common/utils/getUrlParam';

@Component
export default class VoteBanListModal extends Vue {
  @Prop({ required: true }) chooseItem!: any;

  showConfirm: boolean = false;

  handleCloseModal() {
    this.$emit("hide");
  }

  handleClickUnfreeze() {
    if (this.chooseItem.isForbidden) {
      this.showConfirm = true;
    }
  }

  // 点击取消按钮
  handleConfirmCancle() {
    this.showConfirm = false;
  }

  // 点击确定按钮
  handleConfirmOk() {
    const version = getUrlParam("v") || getUrlParam("vn");
    const token = getUrlParam("token");
    const uid = getUrlParam("uid");
    const aid = getUrlParam("aid");
    const param = {
      p: "h5",
      v: "v" + version,
      token,
      uid,
      aid,
      activityId: this.chooseItem.activityId,
      optId: this.chooseItem.id
    };

    fetch.Sales('public/businessShow/thawOption', param).then(() => {
      Vue.$toast.success("解封成功");
      this.$emit("hide", true);
      this.showConfirm = false;
    });
  }
}
